import { ProductBySlugQuery_productBySlug_Product } from "@/Apollo/schema";
import { useLanguage } from "@/common/hooks/pages.hooks";
import { CountryUtils } from "@/utils/CountryUtils";

export const useProductDeliveryProductPickupAddress = (
  product: ProductBySlugQuery_productBySlug_Product
) => {
  const { language } = useLanguage();
  const { address } = product;

  if (!address?.country) {
    return {};
  }

  const countryName = CountryUtils.getCountryName(address.country, language);

  const location = [product.address?.city, countryName]
    .filter(Boolean)
    .join(", ");

  return { address: location };
};
